import { render, staticRenderFns } from "./formAdminCard.vue?vue&type=template&id=54afc00e"
import script from "./formAdminCard.vue?vue&type=script&lang=js"
export * from "./formAdminCard.vue?vue&type=script&lang=js"
import style0 from "./formAdminCard.vue?vue&type=style&index=0&id=54afc00e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports